import React, { useState } from 'react';

import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import PayloadBuilderSetupGuideModal from './PayloadBuilderSetupGuideModal';
import { PAYLOAD_BUILDER_ALERT_BUTTON_SX } from './PayloadBuilderShared';

export default function PayloadBuilderSetupGuide() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="info"
        startIcon={<InfoOutlinedIcon fontSize="small" />}
        onClick={() => setIsOpen(true)}
        sx={PAYLOAD_BUILDER_ALERT_BUTTON_SX}
      >
        How to Create a Campaign
      </Button>
      <PayloadBuilderSetupGuideModal open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
